export const transContsList = evaData =>
  evaData.map(({ eva_template_id, is_usage, title,is_option,content,write_content }) => ({
    checked: !!is_usage,
    text: title,
    id: eva_template_id,
    is_option: is_option,
    content: content,
    write_content: write_content,
  }));
//export const paramsEvalData = evaluatRes =>
//  evaluatRes.map(({ id, starNum, suggest, contsList,typeObj = "" }) => ({
//    user_id: id,
//    star: starNum,
//    typeObj: typeObj,
//    other_eva: suggest,
//    tag_list: contsList.map(({ id, checked }) => ({
//      eva_id: id,
//      is_option: checked ? 1 : 0
//    }))
//  }));
export const paramsEvalData = evaluatRes =>
  evaluatRes.map(({ id, starNum, suggest, contsList,eva_data_choose,typeObj = "" }) => ({
    user_id: id,
    star: starNum,
    typeObj: typeObj,
    other_eva: suggest,
    tag_list: contsList.map(({ id, checked }) => ({
      eva_id: id,
      is_option: checked ? 1 : 0
    })),
    eva_data_choose:eva_data_choose.map(({ id, is_option,content }) => ({
      eva_id: id,
      is_option: is_option === '是' ? 1 : 0,
      content:content,
    })),
  }));
export const transData = (arr, names, evaData, type = "",typeObj = "") =>
  arr.map((item, i) => ({
    id: item,
    type,
    typeObj,
    name: names[i],
    starNum: 0,
    suggest: "",
    contsList: transContsList(evaData),
    eva_data_choose:[]
  }));
